import FilledButtonM from "@common/components/button/FilledButtonM"
import { useApiStatus } from "@common/hooks/useApiStatus"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import championsConstants from "@data/constants/championsConstants"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { pullNextScreenParams } from "@data/redux/actions/navigation"
import { authService } from "@data/services/authService"
import { hasRole } from "@data/utility/ability"
import React, { useContext, useEffect, useRef, useState } from "react"
import { Platform, View } from "react-native"
import { StatusBar } from "@common/systemBars/StatusBar"
import { connect } from "react-redux"
import useNextTodoActivity from "../../common/hooks/useNextTodoActivity"
import ChampionBubble from "./ChampionBubble"

const ChampionIntroScreen = (props) => {
    // ** Component props
    const { navigation, route } = props
    const {
        name,
        nextScreen = null,
        introSuffix = "_intro",
        isTracked = true,
        liveModeOnly = false,
    } = route.params

    const championBubbleRef = useRef()

    const { selectNextActivity, isLoading } = useNextTodoActivity()

    const [buttonLoading, setButtonLoading] = useState(
        props.championIntroViewedRequest
    )

    const [nextScreenParams, setNextScreenParams] = useState(
        props.nextScreenParams
    )

    useEffect(() => {
        props.pullNextScreenParams()
    }, [])

    useEffect(() => {
        if (liveModeOnly && !props.isLiveMode) navigation.goBack()
    }, [props.isLiveMode])

    useApiStatus(authService.championIntroViewed, null, true, () => {
        const { todoActivities, lastActivityId, autoSelectNext } =
            nextScreenParams

        if (todoActivities?.length > 0 && autoSelectNext) {
            const selected = selectNextActivity(todoActivities, lastActivityId)

            if (selected) {
                return
            }
        }

        setButtonLoading(false)

        props.apiIdle(authService.championIntroViewed)
        if (nextScreen) navigation.replace(nextScreen, nextScreenParams ?? {})
        else navigation.goBack()
    })
    const dimensions = useContext(DimensionsContext)

    return (
        <View
            style={{
                flex: 1,
                backgroundColor:
                    Platform.OS !== "web" ? theme.colors.white : null,
                alignItems: "center",
                justifyContent: "space-between",
                width: dimensions?.width,
                alignSelf: Platform.OS !== "web" ? null : "center",
                height: "100%",
            }}
        >
            <ChampionBubble
                name={name}
                ref={championBubbleRef}
                variant={championsConstants?.[name + introSuffix]?.variant}
                texts={championsConstants?.[name + introSuffix]?.texts}
                championPosition="center"
                onNextPress={() => {
                    if (isTracked && hasRole(props.user, "student"))
                        props.apiRequest(
                            authService.championIntroViewed,
                            {},
                            { intro_name: name }
                        )
                    else if (nextScreen)
                        navigation.replace(nextScreen, nextScreenParams ?? {})
                    else navigation.goBack()
                }}
            />

            <View
                style={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: dimensions?.width,
                }}
            >
                <FilledButtonM
                    onPress={() => {
                        championBubbleRef.current?.onChampionBubbleNext()
                    }}
                    disabled={buttonLoading || isLoading}
                    loading={buttonLoading || isLoading}
                    label={"Continuer"}
                    color={theme.colors.primary}
                    style={{
                        width:
                            Platform.OS !== "web"
                                ? dimensions?.width - 20
                                : dimensions?.width / 2,
                        alignSelf: "center",
                        marginTop: 10,
                        marginBottom: 30,
                    }}
                />
            </View>

            <StatusBar
                style="dark"
                backgroundColor={theme.colors.white}
                translucent={false}
            />
        </View>
    )
}
const mapStateToProps = (state) => {
    return {
        championIntroViewedRequest: state.api.championIntroViewed?.request,
        user: state.data.currentUser?.object,
        isLiveMode: state.liveMode.isLiveModeEnabled,
        nextScreenParams: state?.navigation?.nextScreenParams,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    pullNextScreenParams,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChampionIntroScreen)
